<template>
    <v-card class="widget-card" elevation="4">
            <slot>

            </slot>

    </v-card>
</template>

<script>


    export default {
        name: "WidgetCard",
        components: {  },
        data() {
            return {
               
            };
        },
        props: {

        },
        methods: {

        },
        computed: {

        },
    };
</script>

<style scoped>

    .widget-card {
        z-index: 1030;
        width: 335px;
        padding: 10px;
        margin: 5px 5px 5px 5px;
        min-height: 150px;
    }





</style>